/* eslint-disable */
import "./style.css";
import "./index.min.css";
import "../../common/css/common.min.css";
import "../../common/css/header.css";
import "../../common/css/sideMuen.css";
import "./style-ajust.css";
import "./news.less";

import "../../images/1.png";
import "../../images/alipay201305.png";
import "../../images/gift_new.gif";
import "../../images/hot2.gif";
import "../../images/kx_124x47.png";
import "../../images/label_sm_90030.png";
import "../../images/new.gif";
import "../../images/s_info_bg.png";
import "../../images/order_icon.png";
import "../../images/order_icon_active.png";





// 监听内容组件标签栏和地址栏标题端点击事件
import addEvent from "./handler";
addEvent();
// 推荐滑动门事件
import slider from "../../common/js/slidingdoor";
slider("#sliding-door");


if (process.env.NODE_ENV == "development") {
  require('../../common/js/pageInit');
}